<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->
<p-heading tag="h1" class="text-balance mt-fluid-lg">
  {{ 'signup.activateAccount.confirmIdentity.headline' | translate }}
</p-heading>

<myprofile-signup-ui-notification-banner
  class="absolute z-501"
  [isOpen]="openBanner"
  [state]="'error'"
  [message]="'signup.activateAccount.tooManySmsSentError.description'"
  (dismissed)="closeBanner()"
>
</myprofile-signup-ui-notification-banner>

<div class="w-full">
  @if (transactionType$ | async; as transactionType) {
    <div>
      <p-text [size]="{ base: 'sm', m: 'md' }" class="mt-fluid-md text-balance">
        @if (
          transactionType === TransactionType.CONNECT_OWNER ||
          transactionType === TransactionType.NON_CONNECT_OWNER ||
          transactionType === TransactionType.SECONDARY ||
          transactionType === TransactionType.SECONDARY_VEHICLE
        ) {
          <span [innerHTML]="'signup.activateAccount.confirmationCode.intro.label' | translate: { MASKED_MOBILE_NO: mobile }"></span>
        }
        @if (transactionType === TransactionType.ADD_CONNECT_VEHICLE || transactionType === TransactionType.ADD_NON_CONNECT_VEHICLE) {
          <span [innerHTML]="'signup.confirmVehicle.confirmationCode.intro.label' | translate: { MASKED_MOBILE_NO: mobile }"></span>
        }
        @if (
          transactionType === TransactionType.SIMPLIFIED_ADD_NON_CONNECT_VEHICLE ||
          transactionType === TransactionType.SIMPLIFIED_ADD_CONNECT_VEHICLE
        ) {
          <span [innerHTML]="'signup.simplifiedAddVehicle.confirmation.intro.label' | translate: { MASKED_MOBILE_NO: mobile }"></span>
        }
      </p-text>
      @if (
        transactionType === TransactionType.SIMPLIFIED_ADD_NON_CONNECT_VEHICLE ||
        transactionType === TransactionType.SIMPLIFIED_ADD_CONNECT_VEHICLE
      ) {
        <p-text [size]="{ base: 'sm', m: 'md' }" class="mt-fluid-md">
          <span class="md:me-static-xs" [innerText]="'signup.simplifiedAddVehicle.confirmation.incorrectNumber.text' | translate"></span>
          <span class="md:me-static-xs">
            <p-button-pure
              type="button"
              [underline]="true"
              [icon]="'none'"
              data-e2e="simpliefied-add-vehicle-go-to-manual-process"
              [myprofileSignupUiTrack]="{
                clickElementType: 'button',
                clickElementId: 'linkout',
                clickElementName: 'link_to_external-target',
                pageName: currentPageName,
                eventAction: 'PAGMyPorsche_SignUpIdentityRequest_Click',
              }"
              (click)="goToManualAddVehicleProcess()"
            >
              {{ 'signup.simplifiedAddVehicle.confirmation.incorrectNumber.link.text' | translate }}
            </p-button-pure>
          </span>
        </p-text>
      }
      <div>
        <p-button
          (click)="onRequestOTP()"
          class="mt-fluid-lg md:mt-fluid-md w-full xs:w-auto"
          variant="primary"
          data-e2e="confirmation-requestOTP-submit-button"
          [disabled]="!!((otpRequested$ | async) || (otpRequestedBlocked$ | async))"
          [loading]="!!(otpRequested$ | async)"
          [myprofileSignupUiTrack]="{
            clickElementType: 'button',
            clickElementId: 'call_to_action',
            clickElementName: 'request_confirmation_code',
            pageName: currentPageName,
            eventAction: 'PAGMyPorsche_SignUpIdentityRequest_Click',
          }"
        >
          {{ 'signup.activateAccount.confirmationCode.button.label' | translate }}
        </p-button>
      </div>
      <myprofile-signup-ui-cancel-activation></myprofile-signup-ui-cancel-activation>
      @if (isAddVehicleLeanActivation) {
        <p-text class="mt-fluid-md">
          <span [innerHTML]="leanActivationText"></span>
        </p-text>
      }
    </div>
  }
</div>
